import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1306.08595,25.2250056 C1323.25266,-0.750928644 1358.37664,-7.86607585 1384.35257,9.52650621 C1410.32851,26.8061494 1417.33072,61.8171912 1400.05107,87.7931255 L1400.05107,87.7931255 L1314.33049,216.430469 C1343.58165,235.291256 1371.70342,255.846126 1397.45348,279.337406 C1515.92633,387.984574 1581.20498,532.772173 1581.20498,687.046634 L1581.20498,687.046634 L1581.20498,1421.14912 C1581.20498,1509.4673 1505.19714,1581.18347 1411.79671,1581.18347 L1411.79671,1581.18347 L1242.38845,1581.18347 L1242.38845,1920 L1129.4496,1920 L1129.4496,1581.18347 L790.633067,1581.18347 L790.633067,1920 L677.694223,1920 L677.694223,1581.18347 L508.285956,1581.18347 C414.885531,1581.18347 338.877689,1509.4673 338.877689,1421.14912 L338.877689,1421.14912 L338.877689,709.295587 C338.877689,508.716199 446.169591,329.030497 608.123894,220.383329 L608.123894,220.383329 L519.57984,87.9060643 C502.187258,61.9301301 509.189467,26.9190883 535.052462,9.52650621 C560.915457,-7.753137 596.039438,-0.750928644 613.43202,25.1120667 L613.43202,25.1120667 L707.735955,166.172684 C767.593543,140.309688 831.516929,121.56184 899.619052,115.576081 C1008.94385,105.976279 1116.57457,123.4818 1213.70198,163.688029 L1213.70198,163.688029 Z M225.938845,734.142133 L225.938845,1298.83636 L113,1298.83636 L113,734.142133 L225.938845,734.142133 Z M1807.08267,734.142133 L1807.08267,1298.83636 L1694.14382,1298.83636 L1694.14382,734.142133 L1807.08267,734.142133 Z M1185.91902,451.795021 C1123.68972,451.795021 1072.98018,502.504563 1072.98018,564.733866 C1072.98018,626.963169 1123.68972,677.67271 1185.91902,677.67271 C1248.14833,677.67271 1298.85787,626.963169 1298.85787,564.733866 C1298.85787,502.504563 1248.14833,451.795021 1185.91902,451.795021 Z M734.163645,451.795021 C671.934341,451.795021 621.2248,502.504563 621.2248,564.733866 C621.2248,626.963169 671.934341,677.67271 734.163645,677.67271 C796.392948,677.67271 847.102489,626.963169 847.102489,564.733866 C847.102489,502.504563 796.392948,451.795021 734.163645,451.795021 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconAndroidSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconAndroidSolid, _Component);

  var _super = _createSuper(IconAndroidSolid);

  function IconAndroidSolid() {
    _classCallCheck(this, IconAndroidSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconAndroidSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconAndroid",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconAndroidSolid.displayName = "IconAndroidSolid";
  return IconAndroidSolid;
}(Component);

IconAndroidSolid.glyphName = 'android';
IconAndroidSolid.variant = 'Solid';
IconAndroidSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconAndroidSolid;
export { IconAndroidSolid };